import { Icon, type IconProps } from "./icon";

/** Search. */
export function SearchIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="8.75" cy="8.75" r="5.25" />
      <path d="M12.6 12.6l4.4 4.4" />
    </Icon>
  );
}
